var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2315 7.09925H6.80555V13.5252H13.2315V7.09925ZM12.25 12.5437H7.78703V8.08073H12.25V12.5437ZM18.1296 5.2474V4.26591H15.8611V1.66406H14.8796V4.26591H12.1944V1.66406H11.213V4.26591H8.59258V1.66406H7.6111V4.26591H5.03703V1.66406H4.05555V4.26591H1.87036V5.2474H4.05555V7.83073H1.87036V8.81221H4.05555V11.4233H1.87036V12.4048H4.05555V15.0992H1.87036V16.0807H4.05555V18.2937H5.03703V16.1826H7.6111V18.3307H8.59258V16.1826H11.213V18.3307H12.1944V16.1826H14.8796V18.2937H15.8611V16.0807H18.1296V15.0992H15.8611V12.4048H18.1296V11.4233H15.8611V8.81221H18.1296V7.83073H15.8611V5.2474H18.1296ZM14.8796 15.2011H5.03703V5.2474H14.8796V15.2011Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.5b5fae575e12a28a6f3b5f774a5f3921.svg";
export { ForwardRef as ReactComponent };